import React, { useState } from "react";
import UpdatePhoto from "../UpdatePhoto";
import { useDispatch, useSelector } from "react-redux";
import { updateUserSlice } from "../../store/slices/userSlice";
import TextArea from "antd/lib/input/TextArea";
import { GetUser } from "../../services/NewAuthService";
import Alert from "antd/lib/alert";
import notification from "antd/lib/notification";

function AvatarBio({ currStep, setCurrStep, setPayload, payload, isNew }) {
  const dispatch = useDispatch();
  const qalortUser = useSelector((state) => state.user.userData);
  const [bio, setBio] = useState(payload.biography);
  const [loading, setLoading] = useState(false);
  const [bioError, setBioError] = useState(false);
  const [uploadDone, setUploadDone] = useState(qalortUser?.profile || false);
  const minBioLength = 20;
  const maxBioLength = 100;

  const fetchUser = async () => {
    const res = await GetUser();
    const payload = {
      ...qalortUser,
      ...res.data.data,
      full_name: `${res.data.data.first_name} ${res.data.data.last_name}`,
    };
    dispatch(updateUserSlice(payload));
  };

  const onSave = () => {
    if (!uploadDone || qalortUser.profile.includes("default.png")) {
      notification.error({
        description: "Please upload a profile picture to proceed",
      });
      return;
    }
    if (bio.length < minBioLength || bio.length > maxBioLength) {
      setBioError(true);
      return;
    }
    setLoading(true);
    setPayload({ ...payload, biography: bio });
    // const request = updateUserInformation({ bio });
    // request
    //   .then((res) => {
    //     fetchUser();
    //     notification.success({ description: "Profile updated successful" });
    setCurrStep(currStep + 1);
    //   })
    //   .catch((err) => {
    //     notification.error({
    //       description: err.response?.data?.message || "An error occured",
    //     });
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  };

  return (
    <div>
      <UpdatePhoto
        fetchUser={fetchUser}
        isNew={isNew}
        setUploadDone={setUploadDone}
        updatePhotoUrl={(e) => {
          setPayload({
            ...payload,
            ...e,
          });
        }}
        id="fileUpload"
      />
      <br />
      {!uploadDone && (
        <Alert type="info" message="Please upload an avatar to proceed" />
      )}

      <p className="mb-1 text-sm md:mb-1 md:mt-6 text-tint">
        Please enter a brief description of yourself
      </p>
      <TextArea
        className="!placeholder-[#9797BE]"
        rows={6}
        onChange={(e) => {
          setBio(e.target.value);
          setBioError(false);
        }}
        defaultValue={bio}
        minLength={minBioLength}
        maxLength={maxBioLength}
        data-testid="bio_input"
        placeholder="Share your skills!"
      />
      {bioError && (
        <p className="text-[12px] text-red-700">
          Please enter at least {minBioLength} characters or a maximum of{" "}
          {maxBioLength} characters
        </p>
      )}
      <div className="w-full justify-between flex mt-10 md:mt-16 fixed bottom-0 left-0 bg-white [@media(min-width:987px)]:bg-transparent p-5 [@media(min-width:987px)]:p-0 border-neutral [@media(min-width:987px)]:border-0 border-y [@media(min-width:987px)]:relative z-10">
        <button
          onClick={() => setCurrStep(currStep - 1)}
          className="bg-pri-tint border-pri bw-1 px-5 py-3 rounded-lg pri w-1/2 mr-1"
        >
          Previous
        </button>

        <button
          data-testid="next_button"
          onClick={onSave}
          className="bg-pri px-5 py-3 rounded-lg text-white w-1/2 ml-1"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AvatarBio;
